<template>
    <v-card>
        <v-skeleton-loader type="article"></v-skeleton-loader>
        <v-skeleton-loader type="actions"></v-skeleton-loader>
    </v-card>
</template>

<script>
export default {
    name: "PrintDialogSkeleton"
}
</script>